var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-navigation',[(_vm.me && _vm.me.company_type == 'admin')?_c('admin-dashboard'):_vm._e(),(_vm.me && _vm.me.company_type == 'agency')?_c('agency-dashboard'):_vm._e(),(_vm.me && (_vm.me.company_type == 'business' || _vm.me.company_type == 'location'))?_c('business-dashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }